import { Fragment, useEffect, useState } from "react";
import PageTitle from "../../layouts/PageTitle";
import axios from "axios";
import Products from "../AppsMenu/Shop/ProductGrid/Products";
import { Link } from "react-router-dom";
import config from "../../../../config.json";
import "../../../i18n";
import { useTranslation } from "react-i18next";
import "./kitchenLuxe.css";

const ProductsGrid = () => {
  const { t } = useTranslation();
  const [products, setProducts] = useState([]);
  const [error, setError] = useState("");
  const [isError, setIsError] = useState(false);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const fetchProducts = async () => {
    try {
      const response = await axios.get(`${config.dev}/v2/products/retrieve`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
        },
      });

      let data = response?.data || [];

      // Trier les produits pour afficher le dernier créé en premier
      data = data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

      setProducts(data);
      setFilteredProducts(data);
      setIsError(false);
    } catch (err) {
      setError("Failed to fetch products. Please try again later.");
      setIsError(true);
      console.error("Error fetching products:", err);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  useEffect(() => {
    const results = products.filter((product) => {
      // Vérification du prix
      const matchesPrice = product.price
        ? product.price.toString().includes(searchTerm)
        : false;

      // Vérification des détails du produit
      const matchesDetails = product.productDetails
        ? product.productDetails.some((detail) =>
            ["productTitle", "productDescription", "productHistory"].some(
              (key) =>
                detail[key]?.toLowerCase().includes(searchTerm.toLowerCase())
            )
          )
        : false;

      return matchesPrice || matchesDetails;
    });

    setFilteredProducts(results);
  }, [searchTerm, products]);

  return (
    <Fragment>
      <div className="kitchen-page" data-tour="tour-page-products">
        <PageTitle activeMenu={t("products")} motherMenu={t("kitchen")} />
        <div className="kitchen-toolbar">
          <div className="kitchen-toolbar__search">
            <input
              type="text"
              className="form-control"
              placeholder={t("searchByTitle")}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="kitchen-toolbar__actions">
            <Link to={"/add-new-product"} className="kitchen-toolbar__add">
              <i className="fas fa-plus" />
              {t("addNewProduct")}
            </Link>
          </div>
        </div>
        <div className="row kitchen-grid">
          {filteredProducts.length === 0 ? (
            <div className="col-12">
              <div className="kitchen-empty" role="alert">
                {t("noDataFound")}
              </div>
            </div>
          ) : (
            filteredProducts.map((product) => (
              <Products
                key={product._id}
                fetchProducts={fetchProducts}
                product={product}
              />
            ))
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default ProductsGrid;
